var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('switch-hold-header',{attrs:{"supplier-name":_vm.switchHold.supplierName,"reference-number":_vm.switchHold.referenceNumber,"completion-date":_vm.switchHold.completionDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }